import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">
              moosera<span className="footer-accent">.llc</span>
            </h3>
            <p className="footer-tagline">
              Empowering businesses with intelligent AI solutions
            </p>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">AI Agent Development</a></li>
              <li><a href="#services">AI Strategy Consulting</a></li>
              <li><a href="#services">Enterprise AI Solutions</a></li>
              <li><a href="#services">AI Integration</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#case-studies">Capabilities</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:yang.chen@moosera.llc">yang.chen@moosera.llc</a></li>
              <li><a href="#hero">LinkedIn</a></li>
              <li><a href="#hero">GitHub</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} Moosera LLC. All rights reserved.</p>
          <div className="footer-links">
            <a href="#hero">Privacy Policy</a>
            <a href="#hero">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

